<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <br>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <template>
      <v-card>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title class="ml-2">Homework Submission</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card max-width="400" class="mx-auto">
          <v-container fluid>
            <v-row dense align="center">
              <v-card elevation="0" class="mx-auto">
                <v-row align="center">
                  <v-card-text class="text-h5 font-weight-bold">Academic Year&nbsp; : {{ academic_year }}</v-card-text>
                </v-row>
              </v-card>
              <v-card elevation="0" class="mx-auto">
                <v-row align="center">
                  <v-card-text class="text-h5 font-weight-bold">Standard &nbsp; : {{ standard }}</v-card-text>
                </v-row>
              </v-card>
              <v-card elevation="0" class="mx-auto">
                <v-row align="center">
                  <v-card-text class="text-h5 font-weight-bold">Division &nbsp; : {{ division }}</v-card-text>
                </v-row>
              </v-card>
            </v-row>
          </v-container>
        </v-card>
        <v-radio-group v-model="sort" row class="mt-5 ml-5">
          <v-radio color="red" value="Pending" class="mr-n1"> </v-radio>
          <span style="color: red">
            <strong>Pending </strong>
          </span>

          <v-radio color="green" value="Completed" class="mr-n1 ml-3"></v-radio>
          <span style="color: green">
            <strong>Completed</strong>
          </span>
        </v-radio-group>
      </v-card>
    </template>
    <br />
    <v-card>
      <v-row align="center" justify="center" v-if="course_list != null && this.sort == 'Pending'">
        <v-col cols="12" sm="4" md="4">
              <v-select v-model="course_model" :items="filteredELSubjects2" item-text="course_name" item-value="course_offering_id"
 label="Search Subject wise Homework" return-object chips dense clearable outlined
            @change="searchCoursefilteredList2()">
          </v-select>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-select v-model="assigned_date_filter" :items="assigned_date_filter_list" label="Search Date-wise Homework"
            chips dense clearable outlined @change="searchCoursefilteredList()">
          </v-select>
        </v-col>
      </v-row>
      <v-card-text>
        <template>
          <!--Pending Homework Cards-->
          <div class="row" v-if="this.sort == 'Pending'">
            <v-col cols="12" sm="4" md="3" v-for="(item, index) in sorted_list" :key="index">
              <v-card class="mt-2 ml-2 border" outlined>
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="text-overline mb-4">
                      Subject-
                      <span style="color: indigo">
                        <strong>
                          {{ item.subject }}
                        </strong>
                      </span>
                      <br />
                      Course Instructor-
                      <span style="color: indigo">
                        <strong>
                          {{ item.course_instructor }}
                        </strong>
                      </span>
                    </div>
                    <hr class="mt-n3 mb-2" color="red" />
                    <v-list-item-title class="pt-1 mb-1">
                      Title:-<strong> {{ item.title }}</strong>
                    </v-list-item-title>
                    <v-list-item-title class="mb-1">
                      Assigned Date:-<strong> {{ item.assigned_date }}</strong>
                    </v-list-item-title>
                    <v-list-item-title class="mb-1">
                      Due Date:-<strong> {{ item.due_date }}</strong>
                    </v-list-item-title>
                    <v-list-item-title class="mb-1">
                      <!-- {{item.url}} -->
                      URL:-
                      <span v-if="item.url != '--'">
                        <a :href="item.url" target="_blank">
                          <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
                        </a>
                      </span>
                      <span v-else style="opacity: 0.5;">{{ item.url }}</span>
                    </v-list-item-title>

                    <v-list-item-title class="mb-1">
                      Attachments:-
                      <span style="color: black" v-if="item.download_link == null">
                        <strong>--</strong>
                      </span>
                      <a v-if="item.download_link != null" target="_blank" :href="basepath + item.download_link">
                        <span style="color: indigo">
                          <strong> Attachment </strong>
                        </span>
                      </a>
                    </v-list-item-title>

                    <v-list-item-title class="mb-1">
                      Modal Answer:-
                      <span style="color: black" v-if="item.model_answer_file_link == null">
                        <strong>--</strong>
                      </span>
                      <a v-if="item.model_answer_file_link != null" target="_blank"
                        :href="basepath + item.model_answer_file_link">
                        <span style="color: indigo">
                          <strong> Modal Answer </strong>
                        </span>
                      </a>
                    </v-list-item-title>

                    <v-list-item-title class="pt-1 mb-1">
                      Description:-<strong> {{ item.description }}</strong>
                    </v-list-item-title>
                    <v-list-item-title class="mb-1">
                      Status:-<strong> {{ sort }}</strong>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-card-actions class="mt-n5">
                  <v-btn outlined rounded text @click="proceed(item)" tile color="white" class="button"
                    :disabled="item.ischecked">
                    Proceed
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </div>
          <!--No Pending Homework-->
          <div align="center" v-if="this.pending_homework_list.length < 1 && this.sort != 'Completed'
            ">
            <h1 class="mt-5">No Homeworks Pending</h1>
          </div>
          <!--Submitted Homework Table-->
          <div v-if="this.sort == 'Completed'" class="mt-1">
            <template>
              <v-card>
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                    hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="submitted_homework_list" :search="search" class="mytable">
                  <!--attachments-->
                  <template v-slot:[`item.attachments`]="{ item }">
                    <a target="_blank" :href="basepath + item.attachments" v-if="item.attachments != null">
                      <span style="color: indigo">
                        <strong> Attachment </strong>
                      </span>
                    </a>
                    <span v-if="item.attachments == null">
                      <strong>--</strong>
                    </span>
                  </template>
                  <!--submitted_file_path-->
                  <template v-slot:[`item.submitted_file_path`]="{ item }">
                    <a target="_blank" :href="basepath + item.submitted_file_path"
                      v-if="item.submitted_file_path != null">
                      <span style="color: indigo">
                        <strong> Answer File </strong>
                      </span>
                    </a>
                    <span>
                      <strong v-if="item.submitted_file_path == null">
                        --
                      </strong>
                    </span>
                  </template>
                  <template v-slot:[`item.model_answer`]="{ item }">
                    <a target="_blank" :href="basepath + item.model_answer" v-if="item.model_answer != null">
                      <span style="color: indigo">
                        <strong> Modal Answer </strong>
                      </span>
                    </a>
                    <span v-if="item.model_answer == null">
                      <strong>--</strong>
                    </span>
                  </template>
                  <template v-slot:[`item.url`]="{ item }">
                    <!-- {{item.url}} -->
                    <span v-if="item.url == '--'">
                      <strong>--</strong>
                    </span>
                    <span v-else>
                      <a :href="item.url" target="_blank">
                        <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
                      </a>
                    </span>
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <div>
                      <v-btn color="green" depressed :disabled="item.checked" @click="resubmit(item)">Re-submit</v-btn>
                    </div>
                  </template>

                  <template v-slot:[`item.checked`]="{ item }">
                    <span v-if="item.checked">
                      <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                      <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                  </template>
                </v-data-table>
              </v-card>
            </template>
          </div>
        </template>
      </v-card-text>
    </v-card>
    <!--Submit HomeWork Modal-->
    <v-dialog v-model="submitDialog">
      <v-card>
        <v-form v-model="valid">
          <v-card-title class="ml-6 mb-n1">
            <v-spacer></v-spacer>
            Subject-
            <span style="color: indigo">
              <strong>
                {{ submitHomework.subject }}
              </strong>
            </span>
            <v-divider class="mx-4" inset vertical></v-divider>
            Course Instructor:-
            <span style="color: indigo">
              <strong>
                {{ submitHomework.course_instructor }}
              </strong>
            </span>
            <v-spacer></v-spacer>
          </v-card-title>
          <hr color="indigo" />
          <v-card-text>
            <v-container class="mt-n6">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="mb-1">
                    Title:- <strong> {{ submitHomework.title }}</strong>
                  </v-list-item-title>
                  <v-list-item-title class="mb-1">
                    Assigned Date:-
                    <strong> {{ submitHomework.assign_date }}</strong>
                  </v-list-item-title>
                  <v-list-item-title class="mb-1">
                    Due Date:- <strong> {{ submitHomework.due_date }}</strong>
                  </v-list-item-title>
                  <v-list-item-title class="mb-1">
                    Attachments:-
                    <a target="_blank" v-bind:href="basepath + submitHomework.download_link"
                      v-if="submitHomework.download_link != null">
                      <strong> Attachment </strong>
                    </a>
                    <span style="color: grey" v-if="submitHomework.download_link == null">
                      <strong>--</strong>
                    </span>
                  </v-list-item-title>

                  <v-list-item-title class="mb-1">
                    Modal Answer:-
                    <a target="_blank" v-bind:href="basepath + submitHomework.model_answer_file_link"
                      v-if="submitHomework.model_answer_file_link != null">
                      <strong> Modal Answer </strong>
                    </a>
                    <span style="color: grey" v-if="submitHomework.model_answer_file_link == null">
                      <strong>--</strong>
                    </span>
                  </v-list-item-title>
                  <!-- <v-list-item-title class="mb-1">
                        Status:- 
                    </v-list-item-title> -->
                  <v-list-item-title class="mb-1">
                    Description:
                    <strong>
                      <v-textarea readonly outlined v-model="submitHomework.description"></v-textarea></strong>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-textarea :disabled="!submitHomework.is_assignment" outlined label="Answer"
                v-model="submitHomework.answer" class="ml-4">
              </v-textarea>

              <v-file-input :disabled="!submitHomework.is_assignment" label="Upload Your File"
                v-model="submitHomework.file">
              </v-file-input>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="mb-2 buttonSave ml-50" @click="submit()" :disabled="!valid"
              v-if="submitHomework.is_assignment">Submit</v-btn>
            <v-btn color="mb-2 buttonSave ml-50" @click="submit_material()" v-else>Mark as Read / Seen</v-btn>
            <v-btn color="mb-2 buttonExit ml-50" @click="close">Close</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
          <!-- <v-card-actions>              
          <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>              
        </v-card-actions> -->
        </v-form>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    // errorMsg: {
    //   castId: false
    // },
    sort: "Pending",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    submitDialog: false,
    standard: "",
    division: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    academic_year: "",
    pending_homework_list: [],
    submitted_homework_list: [],
    all_homework_list: [],
    sorted_list: [],
    basepath: null,
    headers: [
      {
        text: "Sr No",
        value: "srno",
      },
      {
        text: "Subject",
        value: "subject",
      },
      {
        text: "Teacher",
        value: "course_instructor",
      },
      {
        text: "Title",
        value: "title",
      },
      {
        text: "Assign Date",
        value: "assigned_date",
      },
      {
        text: "Due Date",
        value: "due_date",
      },
      {
        text: "Attachments",
        value: "attachments",
      },
      {
        text: "URL",
        value: "url",
      },
      {
        text: "Modal Answer",
        value: "model_answer",
      },
      {
        text: "Submitted Date",
        value: "submission_date",
      },
      {
        text: "Submitted File",
        value: "submitted_file_path",
      },
      {
        text: "Answer",
        value: "answer",
      },
      {
        text: "Software Remark",
        value: "software_remark",
      },
      {
        text: "Teacher Remark",
        value: "teacher_remark",
      },
      {
        text: "Marks",
        value: "marks",
      },
      {
        text: "Checked",
        value: "checked",
      },
      {
        text: "Re-Submit",
        value: "action",
        align: "center",
      },
    ],
    submitHomework: {
      id: "",
      subject: "",
      course_instructor: "",
      title: "",
      description: "",
      assign_date: "",
      due_date: "",
      status: "",
      awspath: "",
      answer: "",
      file: null,
      download_link: "",
      model_answer_file_link: "",
      file_name: "",
      is_assignment: "",
    },
    course_list: [],
    course_model: null,
    col_list_new: [],
    assigned_date_filter_list: [],
    assigned_date_filter: [],
  }),

  watch: {
    sort: function (val) {
      this.sort = val;
      if (val == "Pending") {
        this.sorted_list = this.pending_homework_list;
      } else if (val == "Completed") {
        this.sorted_list = this.submitted_homework_list;
      }
      //window.alert(JSON.stringify(this.sorted_list))
    },
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
   computed: {
  filteredELSubjects2() {
    return this.course_list.filter(sub =>
      (sub.course_offering_id !== this.course_model) &&
      sub.course_name !== 'NA:NA'
    );
  }

},

  mounted() {
    this.onLoad();
    this.basepath = localStorage.getItem("awspath");
  },
  methods: {
    resubmit(item) {
      //window.alert(JSON.stringify(item))
      this.proceed(item);
    },
    submit() {
      this.submitDialog = false;
      this.overlay = true;
      let formData = new FormData();
      let hwid = this.submitHomework.id;
      let file = this.submitHomework.file;
      let answer = this.submitHomework.answer;
      formData.append("homework_id", hwid);
      formData.append("file", file);
      formData.append("answer", answer);
      axios
        .post("/Homework/submit_homework", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.submitDialog = false;
            this.overlay = false;
            this.showSnackbar("#4caf50", "HomeWork Submitted Succesfullly...");
            this.submitDialog = false;
            this.submitHomework.id = "";
            this.submitHomework.file = null;
            this.submitHomework.answer = "";
            this.onLoad();
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    submit_material() {
      this.submitDialog = false;
      this.overlay = true;
      let data = {
        hwid: this.submitHomework.id,
      };
      axios
        .post("/Homework/submitMaterialHomework", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.submitDialog = false;
            this.overlay = false;
            this.showSnackbar(
              "#4caf50",
              "Material marked as read succesfullly..."
            );
            this.submitDialog = false;
            this.submitHomework.id = "";
            this.onLoad();
          } else if (res.data.flag == "AS") {
            this.showSnackbar("#b71c1c", "Material is already read / seen!"); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    close() {
      this.submitDialog = false;
    },
    proceed(item) {
      //window.alert(JSON.stringify(item))
      this.submitDialog = true;
      this.submitHomework.id = item.homework_id;
      this.submitHomework.subject = item.subject;
      this.submitHomework.course_instructor = item.course_instructor;
      this.submitHomework.title = item.title;
      this.submitHomework.description = item.description;
      this.submitHomework.assign_date = item.assigned_date;
      this.submitHomework.due_date = item.due_date;
      this.submitHomework.status = item.status;
      this.submitHomework.download_link = item.download_link;
      this.submitHomework.model_answer_file_link = item.model_answer_file_link;
      this.submitHomework.file_name = item.file_name;
      this.submitHomework.is_assignment = item.is_assignment;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Homework/homework_student_homepage")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.standard = res.data.standard;
              this.division = res.data.division;
              this.academic_year = res.data.academic_year;
              this.pending_homework_list = res.data.pending_homeworks;
              this.submitted_homework_list = res.data.submitted_homeworks;
              this.sorted_list = res.data.pending_homeworks;
              this.course_list = res.data.course_list;
              this.assigned_date_filter_list =
                res.data.assigned_date_filter_list;
              //window.alert(JSON.stringify(this.sorted_list))
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    searchCoursefilteredList2() {
      this.col_list_new = [];
      if (this.course_model != null) {
        for (let i = 0; i < this.pending_homework_list.length; i++) {
          var areEqual =
            this.pending_homework_list[i].course_offering_id ==
            this.course_model.course_offering_id;
          if (areEqual) {
            this.col_list_new.push(this.pending_homework_list[i]);
          }
        }
      } else {
        this.onLoad();
      }
      if (this.col_list_new.length > 0) {
        // this.pending_homework_list = this.col_list_new;
        return (this.sorted_list = this.col_list_new);
      } else {
        this.col_list_new = [];
        return (this.sorted_list = this.col_list_new);
      }
    },
    searchCoursefilteredList() {
      this.col_list_new = [];
      if (this.assigned_date_filter != null) {
        for (let i = 0; i < this.pending_homework_list.length; i++) {
          var areEqual =
            this.pending_homework_list[i].assigned_date_filter ==
            this.assigned_date_filter;
          if (areEqual) {
            this.col_list_new.push(this.pending_homework_list[i]);
          }
        }
      } else {
        this.onLoad();
      }
      if (this.col_list_new.length > 0) {
        // this.pending_homework_list = this.col_list_new;
        return (this.sorted_list = this.col_list_new);
      } else {
        this.col_list_new = [];
        return (this.sorted_list = this.col_list_new);
      }
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.buttonSave {
  border: 2px solid #0f2027 !important;
  color: #018d20;
  background: transparent !important;
  border-radius: 50px;
  margin: 0.5rem !important;
  text-align: center;
}

.buttonSave:hover {
  text-align: center;
  color: white !important;
  background: #018d20 !important;
  background: #018d20;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.buttonExit {
  border: 2px solid #0f2027 !important;
  color: #df110a;
  background: transparent !important;
  border-radius: 50px;
  margin: 0.5rem !important;
  text-align: center;
}

.buttonExit:hover {
  text-align: center;
  color: white !important;
  background: #df110a !important;
  background: #df110a;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
</style>